@if(component) {
<div class="flex flex-justify-center">
    <div class="w-12 p-t-10 p-b-10 flex flex-column-m flex-column-s flex-start">
        <div class="w-6 w-12-m w-12-s p-r-5-x p-r-5-l">
            <df-image-wrapper class="overflow-hidden"
                              style="border-radius: 12px;">
                <img [dfImage]="component.image"
                     [ratio]="component.ratio || '4/5'">
            </df-image-wrapper>
            <p *iCms="'imageCaption' of component; skipEmpty: true"
               class="c1 left m-t-2"></p>
        </div>
        <text-box class="w-6 w-12-m w-12-s p-l-5-x p-l-5-l"
                  [data]="component"
                  [textAlign]="'left'"></text-box>
    </div>
</div>
}